import React from 'react';

export function OptimizelyPageProvider(props) {
    return <div {...props} />;
}
export const useOptimizelyFeature = () => ({
    isValidFeature: () => false,
    getForcedFeatures: () => ({}),
});
export const useOptimizelyTrack = () => () => {};
